import moment from "moment";
import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import Box from "@mui/material/Box";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import { Divider } from "@mui/material";
import AttachMoneyRoundedIcon from "@mui/icons-material/AttachMoneyRounded";
import RatingStars from "./RatingStars";
import businessDefaultImg from "../assets/store.png";
import {
  GetRatingShop,
  getMethodPay,
  getDataBankShop,
} from "../Business/Infrastructure/Business.presenter";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import CollapseButton from "./CollapseButton";
import MenuButton from "./MenuButton";
import BusinessImage from "./BusinessImage";
import shopBag from "../assets/shopBagGray.svg";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";

const scheduleStyles = {
  color: "#4f4f4f",
  height: "15px",
  width: "15px",
};

const stats = {
  width: "100%",
  height: "34px",
  display: "flex",
  justifyContent: { xs: "start", md: "space-around" },
  background: { xs: "#FFF", md: "#F2F2F2" },
  borderRadius: "10px",
  alignSelf: "start",
  alignItems: "center",
  gap: { xs: "15px", md: "0px" },
};

const infoContainer = {
  paddingLeft: "10px",
  display: { xs: "none", md: "flex" },
  alignItems: "start",
  flexDirection: "column",
  gap: "15px",
  width: "100%",
};

const infoContainerMobile = {
  //alignSelf:"start",
  padding: "10px 20px 15px",
  display: "flex",
  alignItems: "start",
  flexDirection: "column",
  gap: "15px",
  width: "100%",
};

const headerInfo = {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: "12px",
};

const priceStyles = {
  color: "#4f4f4f",
  height: { xs: "12px", lg: "14px" },
  width: { xs: "12px", lg: "14px" },
};

const scheduleContainer = {
  width: "360px",
  height: "auto",
  background: "#F2F2F2",
  borderRadius: "10px",
  padding: "15px 30px",
};

const useStyles = makeStyles((theme) => ({
  principalContainer: {
    marginTop: 20,
    background: "#FFFFFF",
    borderRadius: 10,
    maxWidth: 435,
    minHeight: "100vh",
    padding: "20px 25px 15px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "column",
    gap: 35,
    [theme.breakpoints.down("md")]: {
      gap: 18,
      maxWidth: "100%",
      width: "100%",
      padding: "50px 55px 55px",
      marginTop: 0,
    },
  },
  businessImage: {
    border: "1px solid #F2F2F2",
    boxSizing: "border-box",
    borderRadius: 10,
    objectFit: "cover",
    width: "90%",
    height: "auto",
    maxHeight: 261,
    [theme.breakpoints.down("md")]: {
      maxHeight: 99,
      width: "100%",
      position: "relative",
    },
  },
  businessPrice: {
    display: "flex",
    justifyContent: "center",
  },
  centerAlign: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 3,
  },
  businessHours: {
    fontWeight: 400,
    fontSize: "0.8125rem",
    color: "#4F4F4F",
    lineHeight: "15.85px",
    [theme.breakpoints.down("md")]: {
      fontSize: "0.6875rem",
    },
  },
  businessName: {
    paddingLeft: 10,
    maxWidth: 290,
    color: "#333333",
    alignSelf: "start",
    fontWeight: 700,
    fontSize: "3rem",
    lineHeight: "58.09px",
    [theme.breakpoints.down("md")]: {
      order: -5,
      fontSize: "1.875rem",
      fontWeight: 500,
    },
  },
  businessDescription: {
    marginTop: 12,
    paddingLeft: 10,
    maxWidth: 325,
    color: "#4f4f4f",
    fontSize: "1.125rem",
    fontWeight: 400,
    lineHeight: "21.94px",
    textAlign: "left",
  },
  titleInfo: {
    lineHeight: "29.05px",
    fontWeight: 600,
    color: "#333333",
    fontSize: "1.5rem",
  },
  text: {
    color: "#4F4F4F",
    fontSize: "1.125rem",
    lineHeight: "22px",
    [theme.breakpoints.down("md")]: {
      fontSize: "0.875rem",
    },
  },
  textData: {
    color: "red",
    fontSize: "1.125rem",
    lineHeight: "22px",
    [theme.breakpoints.down("md")]: {
      fontSize: "0.875rem",
    },
  },
  textDataTrue: {
    color: "green",
    fontSize: "1.125rem",
    lineHeight: "22px",
    [theme.breakpoints.down("md")]: {
      fontSize: "0.875rem",
    },
  },
  key: {
    fontWeight: 500,
  },
  value: {
    fontWeight: 400,
  },
  menuButtons: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 15,
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  headerHelp: {
    marginBottom: 15,
    width: "100%",
    order: -6,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
}));

const setPriceIcons = (num) => {
  let price = [];
  for (let i = 0; i < num; i++) {
    price.push(<AttachMoneyRoundedIcon key={i} sx={priceStyles} />);
  }
  return price;
};

export default function BusinessDetailsCard({
  id,
  image,
  name,
  description,
  price,
  ownerName = "No disponible",
  adviserName,
  createdAt,
  sellerName,
  schedule,
}) {
  const classes = useStyles();
  const history = useHistory();
  const formatedDate = moment(new Date(createdAt)).format("DD/MM/YYYY");
  const [stars, setStars] = useState(0);
  const [method_pay, setMethod] = useState("");
  const [dataBank, setBank] = useState("");
  const [card, setCard] = useState("");
  const [clb, setclb] = useState("");
  const [statusShop, setShopStatus] = useState(false);

  useEffect(() => {
    shopRating();
    methodPay();
    checkDataBank();
  }, []);

  const shopRating = async () => {
    try {
      const response = await GetRatingShop(id);
      if (isNaN(response)) {
        setStars(0);
      } else {
        setStars(response.toFixed(2));
        console.log("rating", response);
      }
    } catch (error) {
      console.log("error en rating shop", error);
    }
  };

  const methodPay = async () => {
    const getMethod = await getMethodPay(id);
    setMethod(
      getMethod.data.getShop.method_pay != null
        ? getMethod.data.getShop.method_pay
        : "No disponible"
    );
  };

  useEffect(() => {
    const getStatusFn = async () => {
      const getStatus = await getMethodPay(id);
      setShopStatus(getStatus.data.getShop.status);
      console.log("getStatus", statusShop);
    };
    getStatusFn();
  }, [statusShop]);

  const checkDataBank = async () => {
    const res = await getDataBankShop(id);
    var dataBd = "";
    var clbfn ="", cardfn = "";

    if (res.data.getShop.interclb != null) {
      dataBd = JSON.parse(res.data.getShop.interclb);
      clbfn = dataBd.idclabe != null && dataBd.idclabe != undefined ? dataBd.idclabe : "";
      setclb(clbfn);
      cardfn = dataBd.idcard != null && dataBd.idcard != undefined ? dataBd.idcard : "";
      setCard(cardfn);
    } else {
      dataBd = "ño hay";
    }
    setBank(dataBd);
  };

  console.log("stars", dataBank, card,clb);

  return (
    <div className={classes.principalContainer}>
      <div className={classes.headerHelp}>
        <ChevronLeftOutlinedIcon
          sx={{
            width: "24px",
            height: "24px",
            display: { md: "none" },
            color: "#004990",
          }}
          onClick={() => history.push(`/negocios`)}
        />
        <h4 style={{ color: "#004990", fontSize: "0.875rem", fontWeigh: 700 }}>
          Ayuda
        </h4>
      </div>
      <img
        className={classes.businessImage}
        src={image || businessDefaultImg}
        alt={name}
      />
      <Box sx={stats}>
        {(!schedule ||
          typeof schedule === "string" ||
          schedule.length === 0) && (
          <p className={`${classes.businessHours} ${classes.centerAlign}`}>
            <AccessTimeOutlinedIcon sx={scheduleStyles} /> - - -{" "}
          </p>
        )}
        <div className={classes.businessPrice}>
          {price !== 0 && setPriceIcons(price)}
        </div>
        <p className={classes.centerAlign}>
          <RatingStars rating={stars} />
        </p>
      </Box>
      <h3 className={classes.businessName}>{name}</h3>
      <Box sx={{ alignSelf: "start" }}>
        <p className={classes.businessDescription}>
          {description || "Sin descripción"}
        </p>
      </Box>
      <Divider />
      <div className={classes.menuButtons}>
        <CollapseButton
          title="Ver información"
          icon={<InfoOutlinedIcon sx={{ color: "#4F4F4F" }} />}
        >
          <Box sx={infoContainerMobile}>
            <Box sx={headerInfo}>
              <p className={`${classes.key} ${classes.text}`}>Encargado:</p>
              <p className={`${classes.value} ${classes.text}`}>
                {sellerName || "No disponible"}
              </p>
            </Box>
            <Box sx={headerInfo}>
              <p className={`${classes.key} ${classes.text}`}>Dueño:</p>
              <p className={`${classes.value} ${classes.text}`}>
                {ownerName || "No disponible"}
              </p>
            </Box>
            <Box sx={headerInfo}>
              <p className={`${classes.key} ${classes.text}`}>Afiliador:</p>
              <p className={`${classes.value} ${classes.text}`}>
                {adviserName || "No dispobible"}
              </p>
            </Box>
            <Box sx={headerInfo}>
              <p className={`${classes.key} ${classes.text}`}>
                Fecha de afiliación:
              </p>
              <p className={`${classes.value} ${classes.text}`}>
                {formatedDate}
              </p>
            </Box>
          </Box>
        </CollapseButton>
        <MenuButton
          title="Abrir ubicación"
          icon={<FmdGoodOutlinedIcon sx={{ color: "#4F4F4F" }} />}
          onClick={() => history.push(`/negocio/${id}/ubicacion`)}
        />
        <MenuButton
          title="Ver productos"
          icon={<img src={shopBag} alt="Shop bag" />}
          onClick={() => history.push(`/negocio/${id}/productos`)}
        />
        <MenuButton
          title="Ver reportes"
          icon={<FolderOutlinedIcon sx={{ color: "#4F4F4F" }} />}
          onClick={() => null}
        />
      </div>
      <Box sx={infoContainer}>
        <Box sx={headerInfo}>
          <InfoOutlinedIcon
            sx={{ color: "#EA5B13", width: "24px", height: "24px" }}
          />

          <h4 className={classes.titleInfo}>Información</h4>
        </Box>
        <Box sx={scheduleContainer}>
          <p className={`${classes.key} ${classes.text}`}>
            Habilitada para venta:
          </p>
          <p className={`${classes.value} ${classes.text}`}>
            { statusShop ? "Habilitada" :  "Aun no esta habilitada"}{" "}
          </p>
        </Box>
        <Box sx={scheduleContainer}>
          <p className={`${classes.key} ${classes.text}`}>
            Método de pago seleccionado:
          </p>
          <p className={`${classes.value} ${classes.text}`}>
            {method_pay.toUpperCase()}{" "}
          </p>
        </Box>
        <Box sx={scheduleContainer}>
          <p className={`${classes.key} ${classes.text}`}>
            CLABE Interbancaria:
          </p>
          <p
            className={`${classes.value} ${
              clb != "" ? classes.textDataTrue : classes.textData
            }`}
          >
            {clb != "" ? "Completado" : "Incompleto"}
          </p>
        </Box>
        <Box sx={scheduleContainer}>
          <p className={`${classes.key} ${classes.text}`}>Tarjeta de cobro</p>
          <p
            className={`${classes.value} ${
              card != "" ? classes.textDataTrue : classes.textData
            }`}
          >
            {card != "" ? "Completado" : "Incompleto"}
          </p>
        </Box>
        <Box sx={headerInfo}>
          <p className={classes.key}>Encargado:</p>
          <p className={classes.value}>{sellerName || "No disponible"}</p>
        </Box>
        <Box sx={headerInfo}>
          <p className={classes.key}>Dueño:</p>
          <p className={classes.value}>{ownerName || "No disponible"}</p>
        </Box>
        <Box sx={headerInfo}>
          <p className={classes.key}>Afiliador:</p>
          <p className={classes.value}>{adviserName || "No disponible"}</p>
        </Box>
        <Box sx={headerInfo}>
          <p className={classes.key}>Fecha de afiliación:</p>
          <p className={classes.value}>{formatedDate}</p>
        </Box>
      </Box>
      {typeof schedule !== "string" && schedule.length !== 0 && (
        <Box sx={scheduleContainer}>
          <Box sx={headerInfo}>
            <AccessTimeRoundedIcon
              sx={{ color: "#EA5B13", width: "24px", height: "24px" }}
            />
            <h4 className={classes.titleInfo}>Horario</h4>
          </Box>
          {schedule.map((day, index) => (
            <p key={index} style={{ marginTop: "7px", marginBottom: "7px" }}>
              {day}
            </p>
          ))}
        </Box>
      )}
    </div>
  );
}
